module.exports = __webpack_public_path__ + "static/media/probuddyThumbnail-facebook-1200X630.6cbabcea.png";